import React, { useCallback, useEffect } from 'react';
import { times } from 'underscore';
import { PASSCODE_LENGTH } from '@theme/js/components/main/SmsVerification/constants';

import style from './index.scss';

type PasscodeInputProps = {
    passcode: string,
    setPasscode: (passcode: string) => void,
    handleSubmit: (passcode: string) => void,
}

const PasscodeInput: React.FC<PasscodeInputProps> = React.memo(({ passcode, handleSubmit, setPasscode }) => {
    const handleOnChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        e.target.selectionStart = e.target.value.length;
        if (/^\d{0,6}$/.test(value)) {
            setPasscode(value);
        }
    }, [setPasscode]);

    useEffect(() => {
        const abort = new AbortController();

        if ('OTPCredential' in window) {
            navigator.credentials.get({
                // @ts-expect-error incorrect base type
                otp: { transport: ['sms'] },
                signal: abort.signal
            })
            .then(otp => {
                // @ts-expect-error incorrect base type
                setPasscode(otp?.code);
                // @ts-expect-error incorrect base type
                handleSubmit(otp?.code);
            })
            .catch(err => console.log('[OTP] - ', err));
        }

        return () => abort.abort('OTP listener disconnected');
        // eslint-disable-next-line
    }, []);

    return (
        <label className={style.container}>
            <div className={style.inputCellsContainer}>
                {times(PASSCODE_LENGTH, (index) => {
                    const number = passcode[index] || '';
                    return (
                        <div key={index} className={style.inputCell}>{number}</div>
                    );
                })}
            </div>
            <input
                className={style.input}
                value={passcode}
                onChange={handleOnChange}
                autoComplete="one-time-code"
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
            />
        </label>
    );
});

export { PasscodeInput };
